/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { User } from '../../models/user';

export interface UserPut$Params {
  userId: number;
  practiceId: string | null;
  isnoehruser?: boolean;
  resetPwd?: boolean;
      body: User
}

export function userPut(http: HttpClient, rootUrl: string, params: UserPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userPut.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('practiceId', params.practiceId, {});
    rb.query('isnoehruser', params.isnoehruser, {});
    rb.query('resetPwd', params.resetPwd, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userPut.PATH = '/api/practices/{practiceId}/users/{userId}';
